module.exports = __webpack_public_path__ + "img/motorway_10x3.ef4eb4cf.svg";